import React from "react";
import Preloader from "../helper/Preloader";
import ColorInit from "../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import HeaderThree from "../components/HeaderThree";
import BannerThree from "../components/BannerThree";
import PromotionalThree from "../components/PromotionalThree";
import FeatureThree from "../components/FeatureThree";
import TextSlider from "../components/TextSlider";
// import TrendingThree from "../components/TrendingThree";
import DiscountThree from "../components/DiscountThree";
import NewArrivalThree from "../components/NewArrivalThree";
// import DealsSection from "../components/DealsSection";
// import PopularProductsThree from "../components/PopularProductsThree";
import Shipping from "../components/Shipping";
import InstagramSection from "../components/InstagramSection";
import Footer from "../components/Footer";
import NewsletterTwo from "../components/NewsletterTwo";

const HomePage = () => {
  return (
    <>
      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color='var(--brand-primary)' />

      {/* Preloader */}
      <Preloader />

      {/* HeaderThree */}
      <HeaderThree />

      {/* BannerThree */}
      <BannerThree />

      {/* TextSlider */}
      <TextSlider />

      {/* PromotionalThree */}
      <PromotionalThree />

      {/* FeatureThree */}
      <FeatureThree />

      {/* TrendingThree */}
      {/* <TrendingThree /> */}

      {/* DiscountThree */}
      <DiscountThree />

      {/* NewArrivalThree */}
      <NewArrivalThree />

      {/* DealsSection */}
      {/* <DealsSection /> */}

      {/* PopularProductsThree */}
      {/* <PopularProductsThree /> */}

      {/* Shipping */}
      <Shipping />

      {/* InstagramSection */}
      <InstagramSection />

      {/* NewsletterTwo */}
      <NewsletterTwo />
      {/* Footer */}
      <Footer />
    </>
  );
};

export default HomePage;